const OtherSourceOfIncomeEnum = {
  Other: { value: 'Other', name: 'Other' },
  RetirementSSI: { value: 'RetirementSSI', name: 'RetirementSSI' },
  Investments: { value: 'Investments', name: 'Investments' },
  Rental: { value: 'Rental', name: 'Rental' },
};

export default OtherSourceOfIncomeEnum;
